/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleGroupListRes } from '../../models/role-group-list-res';

export interface ApiRoleAllGet$Params {
}

export function apiRoleAllGet(http: HttpClient, rootUrl: string, params?: ApiRoleAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RoleGroupListRes>>> {
  const rb = new RequestBuilder(rootUrl, apiRoleAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RoleGroupListRes>>;
    })
  );
}

apiRoleAllGet.PATH = '/api/role/all';
